import {
  BestAds,
  TotalProfitsAndLosses,
  ProfitsAndLossesByDays,
  WorstAds,
  StatsByAdAccount,
  IntegrationQuickReports,
  NetworkQuickReports,
  ProfitsAndLossesByChannel,
  ProductSales,
  ProductBundles,
  SalesByCountry,
  PostbackQuickReports,
} from './index';
import {
  PnLByDaysChart,
  IntegrationReportsChart,
  PnLByChannelsChart,
  NetworkReportsChart,
  PostbackReportsChart,
} from '../charts';

const table_position = {
  lg: { x: 0, y: 0, w: 6, h: 6 },
  md: { x: 0, y: 0, w: 12, h: 6 },
  sm: { x: 0, y: 0, w: 12, h: 6 },
};

const quick_report_position = {
  lg: { x: 0, y: 0, w: 12, h: 2 },
  md: { x: 0, y: 0, w: 6, h: 3 },
  sm: { x: 0, y: 0, w: 2, h: 6 },
};

const quick_chart_position = {
  lg: { x: 0, y: 0, w: 6, h: 4 },
  md: { x: 0, y: 0, w: 6, h: 4 },
  sm: { x: 0, y: 0, w: 4, h: 4 },
};

const integration_position = {
  lg: { x: 0, y: 0, w: 12, h: 6, minW: 6 },
  md: { x: 0, y: 0, w: 6, h: 12, minW: 12 },
  sm: { x: 0, y: 0, w: 1, h: 23, minW: 8 },
};

export const widgetComponents = {
  daily_profit: {
    title: 'Total P&L',
    Component: TotalProfitsAndLosses,
    defaultFilter: {
      network_account_ids: [],
      adset_ids: [],
      ad_ids: [],
      campaign_ids: [],
    },
    position: quick_report_position,
  },

  // Networks quick reports
  facebook_daily_statistics: {
    title: 'Meta Quick Reports',
    Component: NetworkQuickReports,
    defaultFilter: {
      network: 'facebook',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_report_position,
  },

  tiktok_quick_report_positions: {
    title: 'TikTok Quick Reports',
    Component: NetworkQuickReports,
    defaultFilter: {
      network: 'tiktok',
      group_by: 'date',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_report_position,
  },

  google_daily_statistics: {
    title: 'Google Quick Reports',
    Component: NetworkQuickReports,
    defaultFilter: {
      network: 'google',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_report_position,
  },

  bing_daily_statistics: {
    title: 'Bing Quick Reports',
    Component: NetworkQuickReports,
    defaultFilter: {
      network: 'bing',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_report_position,
  },
  //

  // Networks Chart
  googleReportsChart: {
    title: 'Google Reports',
    Component: NetworkReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: { network: 'google', group_by: 'date', network_account_ids: [] },
    position: quick_chart_position,
  },

  bingReportsChart: {
    title: 'Bing Reports',
    config: { showXAxis: true, showYAxis: true },
    Component: NetworkReportsChart,
    defaultFilter: {
      network: 'bing',
      group_by: 'date',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_chart_position,
  },

  tiktokReportsChart: {
    title: 'TikTok Reports',
    config: { showXAxis: true, showYAxis: true },
    Component: NetworkReportsChart,
    defaultFilter: { network: 'tiktok', group_by: 'date', network_account_ids: [] },
    position: quick_chart_position,
  },

  metaQuickChart: {
    title: 'Meta Reports',
    config: { showXAxis: true, showYAxis: true },
    Component: NetworkReportsChart,
    defaultFilter: {
      network: 'facebook',
      group_by: 'date',
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: quick_chart_position,
  },
  //

  network_total_statistics: {
    title: 'Stats by Ad Account',
    Component: StatsByAdAccount,
    defaultFilter: {
      statuses: [],
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      adset_ids: [],
    },
    position: table_position,
  },

  daily_statistics: {
    title: 'P&L by Days',
    Component: ProfitsAndLossesByDays,
    defaultFilter: {
      network_account_ids: [],
      group_by: 'date',
      adset_ids: [],
      ad_ids: [],
      campaign_ids: [],
    },
    position: table_position,
  },

  PnLByDaysChart: {
    title: 'P&L by Days',
    Component: PnLByDaysChart,
    load_chart: true,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: {
      network_account_ids: [],
      group_by: 'date',
      adset_ids: [],
      ad_ids: [],
      campaign_ids: [],
    },
    position: quick_chart_position,
  },

  profits_and_losses_by_channels: {
    title: 'P&L by Channels',
    Component: ProfitsAndLossesByChannel,
    defaultFilter: { network_account_ids: [] },
    position: table_position,
  },

  PnLByChannelsChart: {
    title: 'by Channels',
    Component: PnLByChannelsChart,
    load_chart: true,
    config: {
      showXAxis: true,
      showYAxis: true,
      selected_metrics: 'ad_spent',
    },
    defaultFilter: { network_account_ids: [], group_by: 'date' },
    position: quick_chart_position,
  },

  // integrations charts
  revenueQuickCharts: {
    title: 'Revenue Reports Chart',
    Component: IntegrationReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: { group_by: 'date', integration_ids: [] },
    position: quick_chart_position,
  },

  CustomReportsChart: {
    title: 'Custom Reports',
    Component: IntegrationReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: { group_by: 'date', integration: 'custom', integration_type: 'custom' },
    position: quick_chart_position,
  },

  ShopifyReportsChart: {
    title: 'Shopify Reports',
    Component: IntegrationReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: {
      integration_ids: [],
      group_by: 'date',
      integration_type: 'shopify',
      integration: 'shopify',
    },
    position: quick_chart_position,
  },

  WooCommerceReportsChart: {
    title: 'Woocommerce Reports',
    Component: IntegrationReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: {
      integration_ids: [],
      group_by: 'date',
      integration_type: 'woocommerce',
      integration: 'woocommerce',
    },
    position: quick_chart_position,
  },

  postback_reports_charts: {
    title: 'Postback Reports',
    Component: PostbackReportsChart,
    config: { showXAxis: true, showYAxis: true },
    defaultFilter: {},
    position: quick_chart_position,
  },

  worst_ads: {
    title: 'Worst 10 Ad Sets',
    Component: WorstAds,
    defaultFilter: {
      statuses: [],
      network_account_ids: [],
      ad_ids: [],
      campaign_ids: [],
      network: null,
      limit: 10,
      level: 'adset',
    },
    position: table_position,
  },

  best_ads: {
    title: 'Best 10 Ad Sets',
    Component: BestAds,
    defaultFilter: {
      statuses: [],
      network_account_ids: [],
      network: null,
      limit: 10,
      level: 'adset',
    },
    position: table_position,
  },

  // Integration Reports
  custom_integration_widget: {
    title: 'Custom Integration Reports',
    Component: IntegrationQuickReports,
    defaultFilter: { integration_type: 'custom', integration: 'custom' },
    position: integration_position,
  },
  revenue_quick_widget: {
    title: 'Revenue Quick Reports',
    Component: IntegrationQuickReports,
    defaultFilter: { integration_ids: [] },
    position: integration_position,
  },

  shopify_widget: {
    title: 'Shopify Quick Reports',
    Component: IntegrationQuickReports,
    defaultFilter: { integration_ids: [], integration_type: 'shopify' },
    position: integration_position,
  },

  woocommerce_widget: {
    title: 'Woocommerce Quick Reports',
    Component: IntegrationQuickReports,
    defaultFilter: { integration_ids: [], integration_type: 'woocommerce' },
    position: integration_position,
  },

  postback_widget: {
    title: 'Postback Quick Reports',
    Component: PostbackQuickReports,
    defaultFilter: {},
    position: {
      lg: { x: 0, y: 0, w: 9, h: 3 },
      md: { x: 0, y: 0, w: 6, h: 7 },
      sm: { x: 0, y: 0, w: 2, h: 15 },
    },
  },

  product_sales: {
    title: 'Product Sales',
    Component: ProductSales,
    defaultFilter: { integration_ids: [], integration_type: '' },
    position: table_position,
  },

  product_bundles: {
    title: 'Product Bundles',
    Component: ProductBundles,
    defaultFilter: { integration_ids: [], integration_type: '' },
    position: table_position,
  },

  sales_by_country: {
    title: 'Sales By Country',
    Component: SalesByCountry,
    defaultFilter: { integration_ids: [], integration_type: '' },
    position: table_position,
  },
};
